<template>
  <div class="person">
    <img :src="getPerson">
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import person_1 from '@/assets/persons/p_1.png'
import person_2 from '@/assets/persons/p_2.png'
import person_3 from '@/assets/persons/p_3.png'
import person_4 from '@/assets/persons/p_4.png'
import person_5 from '@/assets/persons/p_5.png'
import person_6 from '@/assets/persons/p_6.png'
import person_7 from '@/assets/persons/p_7.png'
import person_8 from '@/assets/persons/p_8.png'
import person_9 from '@/assets/persons/p_9.png'
import person_10 from '@/assets/persons/p_10.png'
import person_11 from '@/assets/persons/p_11.png'
import person_12 from '@/assets/persons/p_12.png'
import person_13 from '@/assets/persons/p_13.png'
import person_14 from '@/assets/persons/p_14.png'
import person_15 from '@/assets/persons/p_15.png'
import person_16 from '@/assets/persons/p_16.png'
import person_17 from '@/assets/persons/p_17.png'
import person_18 from '@/assets/persons/p_18.png'
import person_19 from '@/assets/persons/p_19.png'
import person_20 from '@/assets/persons/p_20.png'
import person_21 from '@/assets/persons/p_21.png'
import person_22 from '@/assets/persons/p_22.png'
import person_23 from '@/assets/persons/p_23.png'
import person_24 from '@/assets/persons/p_24.png'
import person_25 from '@/assets/persons/p_25.png'

export default {
  name: 'Person',
  data() {
    return {
      person_1,
      person_2,
      person_3,
      person_4,
      person_5,
      person_6,
      person_7,
      person_8,
      person_9,
      person_10,
      person_11,
      person_12,
      person_13,
      person_14,
      person_15,
      person_16,
      person_17,
      person_18,
      person_19,
      person_20,
      person_21,
      person_22,
      person_23,
      person_24,
      person_25,
    }
  },
  computed: {
    ...mapGetters('play', ['getCurrentBotPerson', 'getPersonStore']),
    getPerson() {
      if(this.getCurrentBotPerson.type != null) {
        if(this.getCurrentBotPerson.type == 'stock') {
          switch(this.getCurrentBotPerson.data) {
            case 1: return this.person_1;
            case 2: return this.person_2;
            case 3: return this.person_3;
            case 4: return this.person_4;
            case 5: return this.person_5;
            case 6: return this.person_6;
            case 7: return this.person_7;
            case 8: return this.person_8;
            case 9: return this.person_9;
            case 10: return this.person_10;
            case 11: return this.person_11;
            case 12: return this.person_12;
            case 13: return this.person_13;
            case 14: return this.person_14;
            case 15: return this.person_15;
            case 16: return this.person_16;
            case 17: return this.person_17;
            case 18: return this.person_18;
            case 19: return this.person_19;
            case 20: return this.person_20;
            case 21: return this.person_21;
            case 22: return this.person_22;
            case 23: return this.person_23;
            case 24: return this.person_24;
            case 25: return this.person_25;
            default: return '';
          }
        }else if(this.getCurrentBotPerson.type == 'upload') {
          let result = this.getPersonStore.find(object => {
            return object.name == this.getCurrentBotPerson.data;
          })
          return `${result.data}`;
        }else {
          return '';
        }
      } else {
        return '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.person {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  img {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>